module.exports = __webpack_public_path__ + "img/album17_14.1d3a26cc.jpg";